import { apiFetch } from '@/api/request'
import type { ApiResponse } from '@/types/verification'
import type { ContentSnippet, LegalDoc } from '@/api/admin'

const API_ORIGIN = (process.env.VUE_APP_API_ORIGIN || '').replace(/\/$/, '')
const BASE = `${API_ORIGIN}/api/content`

async function parseJson<T>(response: Response): Promise<ApiResponse<T>> {
  const contentType = response.headers.get('content-type') || ''
  if (!contentType.includes('application/json')) {
    throw new Error('API 서버에 연결할 수 없습니다.')
  }
  return (await response.json()) as ApiResponse<T>
}

export async function fetchContentSnippets(keys: string[] = [], group = '') {
  const params = new URLSearchParams()
  if (keys.length) params.set('keys', keys.join(','))
  if (group) params.set('group', group)
  const q = params.toString()
  const response = await apiFetch(`${BASE}/snippets${q ? `?${q}` : ''}`)
  const result = await parseJson<{ snippets: ContentSnippet[] }>(response)
  if (!result.success || !result.data) {
    throw new Error(result.message || '안내 문구를 불러오지 못했습니다.')
  }
  return result.data.snippets
}

export async function fetchLegalDocs(audience: 'SELLER' | 'MEMBER' | 'ALL' = 'MEMBER') {
  const response = await apiFetch(`${BASE}/legal-docs?audience=${encodeURIComponent(audience)}`)
  const result = await parseJson<{ docs: LegalDoc[] }>(response)
  if (!result.success || !result.data) {
    throw new Error(result.message || '약관을 불러오지 못했습니다.')
  }
  return result.data.docs
}

export function snippetsToMap(snippets: ContentSnippet[]): Record<string, string> {
  return snippets.reduce<Record<string, string>>((acc, row) => {
    acc[row.key] = row.body
    return acc
  }, {})
}
